import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { MetaBlock } from '@gem/components';
import { IcGlobeIcon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';

interface IWorkspaceRegion {
  className?: string;
  region: string;
}

export const WorkspaceRegion: FC<IWorkspaceRegion> = observer(({ className, region }) => {
  const { t } = useTranslation();

  return (
    <MetaBlock
      className={className}
      label={t('common_admin_panel_region')}
      Icon={IcGlobeIcon}
    >
      <div data-test="profile-region">{region}</div>
    </MetaBlock>
  );
});
